<template>
  <div class="box-side contribuer">
    <img src="@/assets/images/mascotte/globulo-stars.png" alt="Globulo Quest mascotte" title="Globulo Quest mascotte"/>
    <h4>Envie de contribuer au projet ?</h4>
    <p>Vous souhaitez aider et contribuer à l’évolution de ce projet, que vous soyez une entreprise ou un particulier, vous pouvez nous aider avec des actions à votre portées découvrez dès maintenant comment apporter votre aide.</p>
    <bouton url="./soutenez-nous.html">Soutenir le projet !</bouton>
  </div> 
</template>

<script>
  import Bouton from '@/components/Bouton'
export default {
  components: { Bouton }
}
</script>

<style>
  .box-side  {
    width: 100%;
    background: white;
    border-radius: 15px;
    padding: 20px;
    box-shadow: 0px 0px 15px rgba(0,0,0,0.2);
    margin-top: 150px;  
    margin-bottom: 40px;  
    text-align: left;
    max-width: 300px;
  }
  .box-side img  {      
    display: grid;
    margin: -135px auto 30px;
    position: relative;
  }
  .box-side h4  {  
    font-size: 24px;
    color: #413492;
    line-height: 26px;
    margin-bottom: 20px;
    }
  .box-side p  {  font-size: 14px; }
  .box-side .button {  width: 100%; }
  
</style>
